import SquareFootIcon from "@mui/icons-material/SquareFootRounded";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Slide,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { TransitionProps } from "@mui/material/transitions";
import { DialogTitle } from "components/dialog";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import SizeChart from "../../sizeChart/chart";
import ColorOption from "./colorOption";
import SizeOption from "./sizeOption";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OptionLabel = styled("div")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

export default function Options(): React.ReactElement {
  const [isSizeGuideOpen, setSizeGuideOpen] = React.useState(false);
  const { options, sizes } = useTemplate();

  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));

  const hasSizeGuideButton = React.useMemo(() => {
    if (sizes.length > 0) {
      return true;
    }
    return false;
  }, [sizes]);

  const onSizeGuideOpen = () => {
    setSizeGuideOpen(true);
  };

  const onSizeGuideClose = () => {
    setSizeGuideOpen(false);
  };

  return (
    <React.Fragment>
      <Stack spacing={3}>
        {options.map((option) => {
          switch (option.code) {
            case "COLOR":
              return (
                <div key={option.id}>
                  <OptionLabel>Available {option.name}</OptionLabel>
                  <ColorOption option={option} />
                </div>
              );

            default:
              return (
                <div key={option.id}>
                  <OptionLabel>
                    <Box sx={{ display: "flex" }}>
                      Available {option.name}
                      {hasSizeGuideButton && option.name === "Size" && (
                        <Button variant="link" onClick={onSizeGuideOpen}>
                          <Typography variant="body2">Size Guide</Typography>
                          <SquareFootIcon
                            sx={{
                              transform: "rotate(-90deg)",
                              fontSize: "18px",
                            }}
                          />
                        </Button>
                      )}
                    </Box>
                  </OptionLabel>
                  <SizeOption option={option} />
                </div>
              );
          }
        })}
      </Stack>
      <Dialog
        open={isSizeGuideOpen}
        TransitionComponent={Transition}
        onClose={onSizeGuideClose}
        maxWidth="sm"
        fullWidth
        fullScreen={matchesSm}
      >
        <DialogTitle title="Size Guide" onClose={onSizeGuideClose} />
        <DialogContent>
          <Box
            sx={{
              minWidth: matchesSm ? "none" : 350,
            }}
          >
            <SizeChart />
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
